const plugins = require.context('./', false, /\.js$/)

const exportFiles = files => files.keys().map(files)

exportFiles(plugins)
